/**
 * Generic debounce for a changing value.
 *
 * Used by the global header search to hold the member-id list steady while
 * someone types: each distinct id set is its own React Query cache key, so
 * feeding it straight from the keystroke would fire a photo query per
 * character typed.
 */

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
